import React from 'react';
import { motion } from 'framer-motion';
import { PawPrint } from 'lucide-react';

const AnalysisLoading = ({}) => {
  return (
    <div className="max-w-md w-full mx-auto bg-white/80 shadow-lg rounded-xl">
      <div className="p-8">
        <div className="flex flex-col items-center justify-center">
          {/* Paw Print with Pulse */}
          <div className="relative mb-8">
            <div className="bg-orange-100 p-4 rounded-full">
              <PawPrint className="h-8 w-8 text-orange-500" />
              <motion.div
                className="absolute -bottom-1 -right-1 h-3 w-3 bg-orange-400 rounded-full"
                animate={{ scale: [1, 1.2, 1] }}
                transition={{
                  duration: 2,
                  repeat: Infinity,
                  ease: "easeInOut"
                }}
              />
            </div>

            {/* Spinning Circle */}
            <motion.div
              animate={{ rotate: 360 }}
              transition={{
                duration: 2,
                repeat: Infinity,
                ease: "linear"
              }}
              className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
            >
              <div className="h-16 w-16 rounded-full border-4 border-orange-200 border-t-orange-500" />
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
};

// For when you need a smaller version
const AnalysisLoadingSmall = ({ title }) => {
  return (
    <div className="flex items-center gap-3 px-4 py-2 bg-white/80 rounded-lg">
      <div className="relative">
        <div className="bg-orange-100 p-2 rounded-full">
          <PawPrint className="h-5 w-5 text-orange-500" />
          <motion.div
            className="absolute -bottom-0.5 -right-0.5 h-2 w-2 bg-orange-400 rounded-full"
            animate={{ scale: [1, 1.2, 1] }}
            transition={{ duration: 2, repeat: Infinity }}
          />
        </div>
      </div>
      <span className="text-sm font-medium text-gray-700">
        {title || "Procesando..."}
      </span>
    </div>
  );
};

export { AnalysisLoading, AnalysisLoadingSmall };